import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"
import styles from "./Returned.module.scss"
import ManageTable from "../../../../views/Manage/ManageTable"
import { Loader } from "react-feather"
import DynamicDropdown from "../../../common/SellerCommonComponents/DynamicDropdown/DynamicDropdown"
import InfoBadge from "../../../common/SellerCommonComponents/InfoBadge/InfoBadge"

const Returned = () => {
  const [loading, setLoading] = useState(true)
  const [selectedOrders, setSelectedOrders] = useState({})

  // State to track dropdown open state for each row
  const [dropdownOpen, setDropdownOpen] = useState({})

  // Function to toggle dropdown for a specific row
  const toggleDropdown = (rowId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [rowId]: !prevState[rowId],
    }))
  }

  const handleCheckboxChange = (orderId, isChecked) => {
    setSelectedOrders((prevSelected) => ({
      ...prevSelected,
      [orderId]: isChecked,
    }))
  }

  const data = [
    {
      id: 1,
      orderId: "#235435745",
      invoice: "Invoice",
      items: 1,
      orderDate: "08/06/2024",
      updateDate: "08/06/2024",
      price: "$33.33",
      paymentMethod: "COD",
      timelyShipping: { date: "21/06/2024", timeLeft: "22 hours left" },
      status: "Returned",
    },
    {
      id: 2,
      orderId: "#235435745",
      invoice: "Invoice",
      items: 1,
      orderDate: "08/06/2024",
      updateDate: "08/06/2024",
      price: "$33.33",
      paymentMethod: "COD",
      timelyShipping: { date: "21/06/2024", timeLeft: "22 hours left" },
      status: "Returned",
    },
  ]

  const columns = [
    {
      name: "Order ID",
      selector: (row) => row.orderId,
      sortable: true,
    },
    {
      name: "Invoice",
      selector: (row) => row.invoice,
    },
    {
      name: "Items",
      selector: (row) => row.items,
      sortable: true,
    },
    {
      name: "Order date",
      selector: (row) => row.orderDate,
      sortable: true,
    },
    {
      name: "Update date",
      selector: (row) => row.updateDate,
      sortable: true,
    },
    {
      name: "Price",
      cell: (row) => row.price,
    },
    {
      name: "Payment method",
      selector: (row) => row.paymentMethod,
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      name: "Action",
      cell: () => (
        <></>
        // <div className="my-1">
        //   <div className="border border-secondary p-1 rounded">Ready to ship</div>
        //   <div className="px-1 mt-1">Cancel</div>
        // </div>
      ),
    },
  ]

  const printDropdownOptions = [
    { label: "Print invoices of selected items", action: () => console.log("print group") },
    { label: "Print shipping labels for selected items", action: () => console.log("print group") },
    { label: "Print stock checklist for selected items", action: () => console.log("print group") },
  ]

  const exportDropdownOptions = [
    { label: "Export all orders", action: () => console.log("export group") },
    { label: "Export all selected orders", action: () => console.log("export group") },
    { label: "Export all pending orders", action: () => console.log("export group") },
    { label: "Export all ready to ship orders", action: () => console.log("export group") },
    { label: "Export all shipped orders", action: () => console.log("export group") },
    { label: "Export all delivered orders", action: () => console.log("export group") },
    { label: "Export all cancelled orders", action: () => console.log("export group") },
    { label: "Export all returned orders", action: () => console.log("export group") },
    { label: "Export all refund only orders", action: () => console.log("export group") },
    { label: "Export all failed delivery orders", action: () => console.log("export group") },
  ]

  const viewHistoryOptions = [
    { label: "Today", action: () => console.log("Viewing history for Today") },
    { label: "Yesterday", action: () => console.log("Viewing history for Yesterday") },
    { label: "Last 7 days", action: () => console.log("Viewing history for Last 7 days") },
    { label: "Last month", action: () => console.log("Viewing history for Last month") },
  ]

  useEffect(() => {
    setLoading(false)
  }, [])

  return (
    <div className={styles.container}>
      <Container fluid className={styles.total}>
        <InfoBadge>Total Orders: 300</InfoBadge>
        <div className="d-flex align-items-center justify-content-between gap-2">
        <DynamicDropdown placeholder="Print" options={printDropdownOptions} />
          <DynamicDropdown placeholder="Export" options={exportDropdownOptions} />
          <DynamicDropdown placeholder="View History" options={viewHistoryOptions} />
        </div>
      </Container>

      {loading ? <Loader /> : <ManageTable name="Pending Orders" columns={columns} tableData={data} isSelectable={true} />}
    </div>
  )
}

export default Returned
